import { styled } from '@mui/material/styles';
import * as React from 'react';

import GenericCard, { GenericCardProps } from './GenericCard';

const StyUnclickableCard = styled(GenericCard, {
    name: 'StyUnclickableCard',
})({
    '& a': {
        cursor: 'initial',
    },
});

const UnclickableCard = (props: GenericCardProps): React.ReactElement => (
    <StyUnclickableCard {...props} />
);

export default UnclickableCard;
